// 应用模版
export default [
    {
        path: '/mytemplate',
        component: () => import('@/pages/Mobile/Find/pages/MyTemplate.vue'),
        meta:{title:"我的AI小程序",requiresAuth:true},
    },
    {
        path: '/createmytemplate',
        component: () => import('@/pages/Mobile/Find/pages/CreateMyTemplate.vue'),
        meta:{title:"创建我的 GPT 应用",requiresAuth:true},
    },
    {
        path: '/selecticon',
        component: () => import('@/pages/Mobile/Find/pages/SelectAppIcon.vue'),
        meta:{title:"选择应用图标",requiresAuth:true},
    },
]